import { apiClient } from '@app/lib'
import { type ApiResponse, type CognitoMfaSettings } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const useMfa = (initialData?: CognitoMfaSettings | null) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    queryKey: ['mfa'],
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<CognitoMfaSettings>>(`/api/mfa`)

      return data.data
    },
    initialData
  })
}
